import {FetchApi as FetchApiClass} from "@monabbous/fetch-api";


// @ts-ignore
export var FetchApi: typeof FetchApiClass = window.FetchApi;
